<div class="logo-container">
  <p>Powered by</p>
  <a href="http://sygnalpartners.com/" target="_blank">
    <img [src]="logoSrc" width="130" />
  </a>
</div>
